'use client';

import React from 'react';
import { SectionHeader, styles } from '../../product-landing/ProductLanding';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import BalanceIcon from '@mui/icons-material/Balance';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import CodeIcon from '@mui/icons-material/Code';

type Persona = {
  label: string;
  description: string;
  icon: string;
};

const ICON_MAP: Record<string, React.ComponentType<{ fontSize?: 'small' | 'medium' | 'large' }>> = {
  BalanceIcon,
  BusinessIcon,
  PersonIcon,
  CodeIcon,
};

export default function WhoIsItForSection() {
  const { t } = useTranslation('start');
  const raw = t('mcp.whoIsItFor.personas', { returnObjects: true });
  const items = (Array.isArray(raw) ? raw : []) as Persona[];
  return (
    <section className={styles.section}>
      <SectionHeader title={t('mcp.whoIsItFor.title')} />
      <div className={styles.cardGrid}>
        {items.map((item, index) => {
          const Icon = ICON_MAP[item.icon] ?? PersonIcon;
          return (
            <article key={`${item.label}-${index}`} className={styles.card}>
              <span className={styles.icon} aria-hidden="true"><Icon /></span>
              <h3>{item.label}</h3>
              <p>{item.description}</p>
            </article>
          );
        })}
      </div>
      <p className={styles.note}>
        {t('mcp.whoIsItFor.accountantsNote')}{' '}
        <Link href="/ai-dla-ksiegowych" className={styles.textLink}>
          {t('mcp.whoIsItFor.accountantsLink')}
        </Link>
      </p>
    </section>
  );
}
